var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyImageProductDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.171,
    height: 60.101,
    viewBox: "0 0 54.171 60.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48806",
    "data-name": "Group 48806",
    transform: "translate(8146.958 13083.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-food-2080123",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, -8107.322, -13082.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73557",
    "data-name": "Path 73557",
    d: "M17.743.986a.986.986,0,0,0-1.971,0V9.857a2.957,2.957,0,1,1-5.914,0V.986a.986.986,0,1,0-1.971,0V9.857a2.957,2.957,0,1,1-5.914,0V.986A.986.986,0,1,0,0,.986v9.857a8.871,8.871,0,0,0,17.743,0Z",
    transform: "translate(0 0)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73558",
    "data-name": "Path 73558",
    d: "M.936,0,0,34.724A2.957,2.957,0,0,0,5.914,34.7L4.979,0A10.864,10.864,0,0,1,2.957.2,10.865,10.865,0,0,1,.936,0Z",
    transform: "translate(5.914 21.49)",
    fill: "#3a3a3c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_38",
    "data-name": "Union 38",
    d: "M5.915,57.89l.933-34.226h0a8.6,8.6,0,0,0,4.048,0l.933,34.194a3.028,3.028,0,0,1-2.957,3.087A3.02,3.02,0,0,1,5.915,57.89ZM0,10.944C0,4.91,3.979,0,8.871,0s8.871,4.91,8.871,10.944S13.764,21.887,8.871,21.887,0,16.978,0,10.944Zm8.871,6.964V19.9c3.8,0,6.9-4.017,6.9-8.954H13.8C13.8,14.784,11.589,17.908,8.871,17.908Z",
    transform: "matrix(0.819, -0.574, 0.574, 0.819, -8146.958, -13073.369)",
    fill: "#3a3a3c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImageProductDark);
export default __webpack_public_path__ + "static/media/emptyImageProductDark.8d3d39b63859e18c9709b0e4fbda4803.svg";
export { ForwardRef as ReactComponent };